import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { AuthAction } from 'src/actions/auth.action';

const Logout = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(AuthAction.logout());
        navigate("/");
    }, []);
};

export default Logout;